export enum LapInfantActionItem {
  Add,
  Update,
  Delete,
}
